<div class="progress-bar-container">
  <div class="progress-bar" [style.background-color]="color" [style.animation-duration]="animationDuration">
  </div>
</div>